import { BLOCK_BACKGROUND_PALETTE_KEY, BLOCK_BACKGROUND_PALETTE_SLOT, } from "../background-palette";
import { promoImageSchema, PROMO_IMAGE_SCREEN_SLOTS } from "./promo-image";
export const arComponentSchema = {
    componentId: "ARComponent",
    scalarSlots: [
        ...promoImageSchema.scalarSlots.filter(slot => slot.key === "title" || slot.key === "titleSize"),
        { key: "label", label: "Button text", type: "text" },
        { key: "vectaryUrl", label: "Vectary URL", type: "url" },
        { key: "qrUrl", label: "QR destination (optional)", type: "url" },
        { key: "dialogTitle", label: "QR dialog title", type: "text" },
        { key: "dialogDescription", label: "QR instructions", type: "textarea" },
        BLOCK_BACKGROUND_PALETTE_SLOT,
    ],
    mediaSlots: PROMO_IMAGE_SCREEN_SLOTS,
    sections: [
        {
            key: "content",
            label: "Content",
            slotKeys: ["title", "titleSize", "label", "vectaryUrl", "qrUrl", "dialogTitle", "dialogDescription"],
        },
        { key: "appearance", label: "Appearance", slotKeys: [BLOCK_BACKGROUND_PALETTE_KEY] },
    ],
};
//# sourceMappingURL=ar-component.js.map